import React, { useEffect } from 'react';
import { useLang } from '../i18n';
import './SecurityPage.css';

export default function SecurityPage() {
  const { t, language } = useLang();

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.title = `${t('security_title')} | Game Pro Hub`;
    document.documentElement.lang = language;
  }, [language, t]);

  const trustHighlights = [
    { title: t('security_payments_title'), text: t('security_payments_text') },
    { title: t('security_access_title'), text: t('security_access_text') },
    { title: t('security_data_title'), text: t('security_data_text') }
  ];

  const sections = [
    { title: t('security_infra_title'), text: t('security_infra_text') },
    { title: t('security_transparency_title'), text: t('security_transparency_text') },
    { title: t('security_privacy_title'), text: t('security_privacy_text') },
    { title: t('security_notice_title'), text: t('security_notice_text') }
  ];

  const faqItems = [
    { q: t('security_faq_account_q'), a: t('security_faq_account_a') },
    { q: t('security_faq_payment_q'), a: t('security_faq_payment_a') },
    { q: t('security_faq_support_q'), a: t('security_faq_support_a') }
  ];

  return (
    <div className="security-page">
      <div className="security-page__bg" aria-hidden="true" />
      <main className="security-page__container">
        <header className="security-page__header">
          <span className="security-page__eyebrow">{t('security_eyebrow')}</span>
          <h1 className="security-page__title">{t('security_title')}</h1>
          <p className="security-page__subtitle">{t('security_subtitle')}</p>
        </header>

        <section className="security-page__highlights">
          {trustHighlights.map((item) => (
            <article key={item.title} className="security-highlight">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </section>

        <section className="security-page__content">
          {sections.map((section) => (
            <article className="security-card" key={section.title}>
              <h2>{section.title}</h2>
              <p>{section.text}</p>
            </article>
          ))}
        </section>

        <section className="security-page__faq">
          <h2>{t('security_faq_title')}</h2>
          <div className="security-page__faq-list">
            {faqItems.map((item) => (
              <article key={item.q} className="security-faq-item">
                <h3>{item.q}</h3>
                <p>{item.a}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="security-page__cta">
          <div className="security-page__cta-badge">{t('security_cta_badge')}</div>
          <h2>{t('security_cta_title')}</h2>
          <p>{t('security_cta_text')}</p>
          <div className="security-page__cta-actions">
            <a className="security-btn security-btn--strong" href="/login">
              {t('security_cta')}
            </a>
          </div>
          <p className="security-page__cta-note">
            {t('security_have_account')} <a href="/login">{t('security_back_app')}</a>
          </p>
        </section>
      </main>
    </div>
  );
}
